import React from 'react'
import { connect } from 'react-redux'
import { GetServerSidePropsContext } from 'next'
import useTranslation from 'next-translate/useTranslation'

import { Registration } from '@/components/PageParts/Registration'

import { PageLayout } from '@/components/Layout/PageLayout'
import { getSettings } from '@/redux/actions'
import { initializeStore } from '@/redux/store'
import { Button } from '@/components/Button'
import { Path } from '@/components/Path'

const RegistrationPage = ({ state }) => {
  const { t } = useTranslation('common')

  return (
    <PageLayout title={`${t('title:register')} | ${state.settings.name}`}>
      <Path pathLinks={[<span>{t('register')}</span>]} />
      <Registration />
    </PageLayout>
  )
}

const mapStateToProps = (state: { state: object }) => ({
  state,
})

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(RegistrationPage)

